import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { getGuests, getGuestStats, getGuestsCsvUrl } from '../api';

export default function GuestsPage() {
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem('rc_user') || 'null');

  const [guests, setGuests] = useState([]);
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(false);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const [pages, setPages] = useState(1);
  const [filters, setFilters] = useState({
    search: '',
    hotel_id: '',
    date_from: '',
    date_to: '',
    phone_confirmed: '',
  });

  useEffect(() => { loadStats(); }, []);
  useEffect(() => { load(); }, [page]);

  async function loadStats() {
    try {
      const res = await getGuestStats();
      setStats(res.data);
    } catch (err) { console.error(err); }
  }

  async function load(resetPage = false) {
    setLoading(true);
    const p = resetPage ? 1 : page;
    if (resetPage) setPage(1);
    try {
      const params = { page: p, limit: 50 };
      if (filters.search)         params.search         = filters.search;
      if (filters.hotel_id)       params.hotel_id       = filters.hotel_id;
      if (filters.date_from)      params.date_from      = filters.date_from;
      if (filters.date_to)        params.date_to        = filters.date_to;
      if (filters.phone_confirmed) params.phone_confirmed = filters.phone_confirmed;
      const res = await getGuests(params);
      setGuests(res.data.guests);
      setTotal(res.data.total);
      setPages(res.data.pages);
    } catch (err) { console.error(err); }
    finally { setLoading(false); }
  }

  function handleLogout() {
    localStorage.removeItem('rc_token');
    localStorage.removeItem('rc_user');
    navigate('/admin/login');
  }

  function formatDate(iso) {
    if (!iso) return '—';
    return new Date(iso).toLocaleDateString('ru-RU', {
      day: '2-digit', month: '2-digit', year: 'numeric'
    });
  }

  function handleExport() {
    const params = {};
    if (filters.hotel_id)        params.hotel_id        = filters.hotel_id;
    if (filters.date_from)       params.date_from       = filters.date_from;
    if (filters.date_to)         params.date_to         = filters.date_to;
    if (filters.phone_confirmed) params.phone_confirmed = filters.phone_confirmed;
    window.open(getGuestsCsvUrl(params), '_blank');
  }

  return (
    <div style={{ minHeight: '100vh', background: '#f5f5f5' }}>
      <nav className="navbar">
        <span className="navbar-brand">🏨 Рег. карты</span>
        <div className="navbar-nav">
          <Link to="/admin" className="nav-link">Заезды</Link>
          <Link to="/admin/archive" className="nav-link">Архив</Link>
          <Link to="/admin/guests" className="nav-link active">Гости</Link>
          <button className="btn btn-outline btn-sm" onClick={handleLogout} style={{ marginLeft: 8 }}>
            Выйти
          </button>
        </div>
      </nav>

      <div className="main">
        <div className="flex items-center justify-between" style={{ marginBottom: 20 }}>
          <h1 style={{ fontSize: 22, fontWeight: 700 }}>База гостей</h1>
          <button className="btn btn-success btn-sm" onClick={handleExport}>
            📊 Экспорт CSV
          </button>
        </div>

        {/* Статистика */}
        {stats && (
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(140px, 1fr))',
            gap: 12, marginBottom: 20,
          }}>
            {[
              { label: 'Всего гостей',    value: stats.total_guests,    icon: '👥' },
              { label: 'С телефоном',     value: stats.with_phone,       icon: '📱' },
              { label: 'С email',         value: stats.with_email,       icon: '📧' },
              { label: 'Повторные',       value: stats.returning_guests, icon: '🔄' },
              { label: 'За 30 дней',      value: stats.last_30_days,     icon: '📅' },
              { label: 'За 7 дней',       value: stats.last_7_days,      icon: '🗓️' },
            ].map(s => (
              <div key={s.label} className="card" style={{ textAlign: 'center', padding: 16 }}>
                <div style={{ fontSize: 24, marginBottom: 4 }}>{s.icon}</div>
                <div style={{ fontSize: 22, fontWeight: 700, color: '#2563eb' }}>
                  {s.value || 0}
                </div>
                <div style={{ fontSize: 12, color: '#6b7280', marginTop: 2 }}>{s.label}</div>
              </div>
            ))}
          </div>
        )}

        {/* Фильтры */}
        <div className="card" style={{ marginBottom: 20 }}>
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))',
            gap: 12
          }}>
            <div>
              <label className="label">Поиск</label>
              <input
                className="input" type="text"
                placeholder="Имя, телефон, email..."
                value={filters.search}
                onChange={e => setFilters(f => ({ ...f, search: e.target.value }))}
              />
            </div>
            <div>
              <label className="label">Последний визит с</label>
              <input
                className="input" type="date"
                value={filters.date_from}
                onChange={e => setFilters(f => ({ ...f, date_from: e.target.value }))}
              />
            </div>
            <div>
              <label className="label">По</label>
              <input
                className="input" type="date"
                value={filters.date_to}
                onChange={e => setFilters(f => ({ ...f, date_to: e.target.value }))}
              />
            </div>
            <div>
              <label className="label">Телефон</label>
              <select
                className="input"
                value={filters.phone_confirmed}
                onChange={e => setFilters(f => ({ ...f, phone_confirmed: e.target.value }))}
              >
                <option value="">Все</option>
                <option value="true">Подтверждён</option>
              </select>
            </div>
          </div>
          <button
            className="btn btn-primary"
            style={{ marginTop: 16 }}
            onClick={() => load(true)}
            disabled={loading}
          >
            {loading ? 'Загрузка...' : '🔍 Найти'}
          </button>
        </div>

        {/* Таблица */}
        {loading ? (
          <div className="flex justify-center" style={{ padding: 60 }}>
            <div className="spinner" />
          </div>
        ) : guests.length === 0 ? (
          <div className="empty">
            <div className="empty-icon">👥</div>
            <p>Гостей не найдено</p>
          </div>
        ) : (
          <>
            <p style={{ fontSize: 14, color: '#6b7280', marginBottom: 12 }}>
              Найдено: <strong>{total}</strong>
            </p>
            <div className="table-wrap" style={{ marginBottom: 20 }}>
              <table>
                <thead>
                  <tr>
                    <th>Гость</th>
                    <th>Телефон</th>
                    <th className="hide-mobile">Email</th>
                    <th className="hide-mobile">Визитов</th>
                    <th className="hide-mobile">Первый</th>
                    <th>Последний</th>
                    <th>Тел. ✓</th>
                  </tr>
                </thead>
                <tbody>
                  {guests.map(g => (
                    <tr key={g.id}>
                      <td><strong>{g.full_name || '—'}</strong></td>
                      <td style={{ fontSize: 13 }}>{g.phone || '—'}</td>
                      <td className="hide-mobile" style={{ fontSize: 13, color: '#6b7280' }}>
                        {g.email || '—'}
                      </td>
                      <td className="hide-mobile" style={{ textAlign: 'center' }}>
                        <span className="badge badge-blue">{g.stays_count}</span>
                      </td>
                      <td className="hide-mobile" style={{ fontSize: 13 }}>
                        {formatDate(g.first_stay)}
                      </td>
                      <td style={{ fontSize: 13 }}>{formatDate(g.last_stay)}</td>
                      <td style={{ textAlign: 'center' }}>
                        {g.phone_confirmed
                          ? <span className="badge badge-green">✓</span>
                          : <span className="badge badge-gray">—</span>
                        }
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {/* Пагинация */}
            {pages > 1 && (
              <div className="flex justify-center gap-8">
                <button
                  className="btn btn-outline btn-sm"
                  onClick={() => setPage(p => Math.max(1, p - 1))}
                  disabled={page === 1}
                >
                  ← Назад
                </button>
                <span style={{ padding: '7px 14px', fontSize: 14, color: '#6b7280' }}>
                  {page} / {pages}
                </span>
                <button
                  className="btn btn-outline btn-sm"
                  onClick={() => setPage(p => Math.min(pages, p + 1))}
                  disabled={page === pages}
                >
                  Вперёд →
                </button>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
}
